module.exports = __webpack_public_path__ + "static/media/hero_header.316bf44e.jpg";